import { useState, useEffect } from 'react';
import { MAX_MOBILE_WIDTH } from '../../constants';

// ignoring as main functionality is matchmedia query and not the initial state value
// JSDOM TESTS initial load at 1024
/* istanbul ignore next */

const getDeviceWidth = () =>
  window.innerWidth <= MAX_MOBILE_WIDTH ? 'mobile' : 'desktop';

const useDeviceTypeListener = () => {
  const [deviceType, setDeviceType] = useState(getDeviceWidth());

  useEffect(() => {
    const mql = window.matchMedia(`(max-width:${MAX_MOBILE_WIDTH}px)`);

    const handleViewChange = (e) => {
      const newType = e.matches ? 'mobile' : 'desktop';
      setDeviceType((prev) => (prev === newType ? prev : newType));
    };

    // Initial check
    handleViewChange(mql);

    mql.addEventListener('change', handleViewChange);
    return () => mql.removeEventListener('change', handleViewChange);
  }, []);

  return deviceType;
};

export default useDeviceTypeListener;
